module.exports = __webpack_public_path__ + "static/media/Stanley.595788b9.png";